module.exports = __webpack_public_path__ + "static/img/cxhzLogoN.5faef80.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cxhzLogoN.jpg
// module id = 1WcT
// module chunks = 2